import React from "react";
import { Box } from "@mui/material";
import AnswerEntity from "./AnswerEntity";
import TabularDataAnswer from "./TabularDataAnswer";
import StreamAnswerWithThinking from "./StreamAnswerWithThinking";
import ParseAnswer from "./ParseAnswer/ParseAnswer";

function Answer({
  answer,
  entity,
  tabular,
  handleEntityChange,
  handleTabularChange,
  showGeneralDomainAnswer,
  setShowGeneralDomainAnswer,
  isMetadataLoading = false,
  isStreaming = false,
  setSelectedSource,
  selectedFileFromStream,
  onSelectedFileFromStreamChange,
  isolationMarkup,
  onIsolationMarkupChange,
  selectedIsolationMarkup,
  onSelectedIsolationMarkupChange,
  lastStreamedMessageId,
}) {
  const answerType = answer["content_object"]["type"];

  return (
    <Box>
      {answerType === "entity" ? (
        <AnswerEntity
          source={entity}
          answer={answer}
          handleEntityChange={handleEntityChange}
        />
      ) : answerType === "tabular_data" ? (
        <TabularDataAnswer
          source={tabular}
          answer={answer}
          handleSourceChange={handleTabularChange}
        />
      ) : (
        <ParseAnswer
          answer={answer}
          setSelectedSource={setSelectedSource}
          selectedFileFromStream={selectedFileFromStream}
          onSelectedFileFromStreamChange={onSelectedFileFromStreamChange}
          isolationMarkup={isolationMarkup}
          onIsolationMarkupChange={onIsolationMarkupChange}
          selectedIsolationMarkup={selectedIsolationMarkup}
          onSelectedIsolationMarkupChange={onSelectedIsolationMarkupChange}
          lastStreamedMessageId={lastStreamedMessageId}
        />
        // <StreamAnswerWithThinking
        //   answer={answer}
        //   showGeneralDomainAnswer={showGeneralDomainAnswer}
        //   setShowGeneralDomainAnswer={setShowGeneralDomainAnswer}
        //   isMetadataLoading={isMetadataLoading}
        //   isStreaming={isStreaming}
        // />
      )}
    </Box>
  );
}

export default Answer;
